/**
 * One translated text for a 403 from the TYPO3 proxy (#113), so every surface
 * says "Your account is waiting for activation…" instead of the raw
 * "Request forbidden: …". The proxy's code survives wrapping in GatewayError.
 */

import { GatewayErrorCode, isGatewayError } from './gateway/error-codes';

type Translate = (key: string) => string;

/** The translated text for a FORBIDDEN error, else null. */
export function forbiddenMessage(error: unknown, t: Translate): string | null {
  if (!isGatewayError(error, GatewayErrorCode.FORBIDDEN)) return null;
  const serverCode = error.details?.serverCode;
  return t(
    serverCode === 'ACCOUNT_PENDING'
      ? 'errors.accountPending'
      : serverCode === 'ORGANIZATION_INACTIVE'
        ? 'errors.organizationInactive'
        : 'errors.forbidden'
  );
}

/** What to show for an error: the 403 text, else its message, else fallback. */
export function errorMessage(
  error: unknown,
  t: Translate,
  fallback: string
): string {
  const forbidden = forbiddenMessage(error, t);
  if (forbidden) return forbidden;
  if (typeof error === 'string' && error) return error;
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
